/**
 * Hasura JWT claim header key. Replace with your Hasura claims path if different.
 */
export const Header = {
  CLAIMS: 'https://hasura.io/jwt/claims',
} as const;
